<template>
  <div class="container justify-content-center" v-bind:class="{'pt-5 pb-5': resultPage.isMobile === true}">
    <div class="feedback-full">
      <feedback-full></feedback-full>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import FeedbackFull from "../Elements/FeedbackFull.vue";

export default {
  name: "FeedbackContent",
  props: {},
  components: {FeedbackFull},
  mixins: [
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>

.feedback-full {
  width: 100%;
  background: white;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  padding: 20px;
}
</style>
